const asFilterPairs = parsed => {
  if (!Array.isArray(parsed)) return [];
  const pairs = [];
  for (const item of parsed) {
    if (!Array.isArray(item) || item.length < 2) continue;
    const key = item[0];
    const value = item[1];
    if (typeof key !== 'string' || typeof value !== 'string') continue;
    pairs.push([key, value]);
  }
  return pairs;
};

export const parseFiltersParam = value => {
  if (value == null || value === '') return [];

  try {
    return asFilterPairs(JSON.parse(value));
  } catch {
    // URLSearchParams already decodes once; a second decode covers double-encoded values.
  }

  try {
    const decoded = decodeURIComponent(value);
    if (decoded === value) return [];
    return asFilterPairs(JSON.parse(decoded));
  } catch {
    return [];
  }
};

export const removeExactFilterPair = (filters, key, value) => {
  if (!Array.isArray(filters)) return [];
  return filters.filter(item => !(Array.isArray(item) && item[0] === key && item[1] === value));
};

export const isPaginationBlocked = ({ isFilterUpdate = false, filterRequestPending = false, pendingCount = 0 } = {}) => {
  return Boolean(isFilterUpdate || filterRequestPending || pendingCount > 0);
};
